import { render, staticRenderFns } from "./PetNameBadge.vue?vue&type=template&id=05d5b8d8&scoped=true&"
import script from "./PetNameBadge.vue?vue&type=script&lang=js&"
export * from "./PetNameBadge.vue?vue&type=script&lang=js&"
import style0 from "./PetNameBadge.vue?vue&type=style&index=0&id=05d5b8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5b8d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
